<div class="bg-col-5 p-a-2 m-b-2 flex flex-wrap">
    <div class="flex flex-justify-end w-12 m-b-3">
        <button (click)="remove()">
            <i class="icon-close"></i>
        </button>
    </div>
    <div class="w-2 p-r-3">
        <div class="w-12 ratio-3-4">
            @if (model.data && model.data.image) {
            <img class="rf"
                 [image]="model.data.image"
                 [alt]="model.name">
            }
        </div>

    </div>
    <div class="w-10">
        <div class="w-8">
            <h5 class="p2">{{model.name}}</h5>
        </div>
        <div class="w-4 right">
            @if (model.data && model.data.is_from_price) {
            <span class="m-r-1 p2">{{'from' | translate}}</span>
            }
            <!-- org price for discount -->
            @if (model.orgPrice) {
            <price class="col-12 s2 inline-block line-through"
                   [value]="model.orgPrice"></price>
            }
            <!-- final price -->
            <price class="m-l-2 inline-block s2"
                   [value]="model.price"></price>

        </div>
        @if (originalModel && originalModel.isConfigurable) {
        <builder-product-configurable-options class="block w-12"
                                              [product]="originalModel"
                                              [familyAttrs]="['color']"
                                              [preselectOptions]="['color']"
                                              [preselectSingles]="true"
                                              [data]="selection!"
                                              [smallVariant]="true"
                                              (selectionChange)="onSelectionChange($event.data)"
                                              (init)="onSelectionChange($event.data)" />
        }
    </div>
</div>